import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "unlocked-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.40684 5.83932C7.92583 3.78467 9.77395 2.25 12 2.25C14.6226 2.25 16.749 4.37578 16.75 6.99814L16.75 9.25H17C18.5192 9.25 19.75 10.4808 19.75 12V19C19.75 20.5192 18.5192 21.75 17 21.75H7C5.48079 21.75 4.25 20.5192 4.25 19V12C4.25 10.4808 5.48079 9.25 7 9.25H15.25V7.00171L15.25 7C15.25 5.20521 13.7948 3.75 12 3.75C10.486 3.75 9.21816 4.79333 8.86116 6.20668C8.75972 6.60828 8.35192 6.8516 7.95032 6.75016C7.54872 6.64872 7.3054 6.24092 7.40684 5.83932ZM7 10.75C6.30921 10.75 5.75 11.3092 5.75 12V19C5.75 19.6908 6.30921 20.25 7 20.25H17C17.6908 20.25 18.25 19.6908 18.25 19V12C18.25 11.3092 17.6908 10.75 17 10.75H7Z"
    }, null, -1)
  ])))
}
export default { render: render }